import React from 'react';
import { img_path } from '../../../environment';

interface Image {
  className?: string;
  src: string;
  alt?: string;
  height?: number;
  width?: number;
  id?: string;
  style?: React.CSSProperties;
  onError?: (event: React.SyntheticEvent<HTMLImageElement, Event>) => void;
  onLoad?: (event: React.SyntheticEvent<HTMLImageElement, Event>) => void;
}

const ImageWithBasePath = (props: Image) => {
  // Função para determinar se deve usar img_path ou não
  const getFullSrc = (src: string): string => {
    // Se já é uma URL completa (começa com http/https), usa como está
    if (src.startsWith('http://') || src.startsWith('https://')) {
      return src;
    }
    
    // Se é uma URL relativa, adiciona o img_path
    return `${img_path}${src}`;
  };

  return (
    <img
      className={props.className}
      src={getFullSrc(props.src)}
      height={props.height}
      alt={props.alt}
      width={props.width}
      id={props.id}
      style={props.style}
      onError={props.onError}
      onLoad={props.onLoad}
    />
  );
};

export default ImageWithBasePath;